import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const StarredContactsZeroState2Icon = (props: IconProps) => (
  <Icon height="32px" width="32px" viewBox="0 0 32 32" {...props}>
    <rect width="32" height="32" fill="#E5F2FF" rx="16" />
    <mask
      id="a"
      width="32"
      height="32"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
      fill="#ffffff"
    >
      <circle cx="16" cy="16" r="16" fill="#ffffff" />
    </mask>
    <path fill="#B3E5C0" d="M-5.12-6.08h63.36V54.4H-5.12z" />
    <path
      fill="#323232"
      d="M14.469 10.49s-.413-2.293.32-3.71c.924-1.782 3.585-2.581 5.805-.868 1.569 1.211.701 4.805.701 4.805l-4.63-1.969-2.196 1.742Z"
    />
    <path
      fill="#F7A283"
      d="m19.618 17.145-1.654 1.573-1.654-1.573.291-3.563h2.726l.291 3.563ZM15.05 10.086s-.392-.252-.695.151c-.303.404-.101 1.918.656 1.918s.039-2.069.039-2.069ZM20.902 10.086s.391-.252.694.151c.303.404.101 1.918-.656 1.918s-.038-2.069-.038-2.069Z"
    />
    <path
      fill="#F7A283"
      d="M21.029 9.666c0-1.699-1.372-2.81-3.065-2.81-1.692 0-3.065 1.111-3.065 2.81 0 0-.133 2.167-.133 2.272 0 1.614 1.976 3.661 3.199 3.661 1.41 0 3.198-2.438 3.198-3.66 0-.106-.134-2.273-.134-2.273Z"
    />
    <path
      fill="#323232"
      d="M20.36 3.315c.049 1.464-.837 2.408-2.168 2.453-1.332.044-1.97-.892-2.02-2.356-.048-1.463.618-2.585 1.95-2.63 1.331-.044 2.189 1.07 2.238 2.533Z"
    />
    <path
      fill="#F7A283"
      d="M17.945 18.85c1.598 0 2.378-1.574 2.003-1.686a41.975 41.975 0 0 0-1.841-.509s-.896.203-2.105.575c-.416.128.39 1.62 1.943 1.62Z"
    />
    <path
      fill="#282644"
      d="M27.743 24.841c-.48-1.436-1.37-3.934-2.427-5.213-.636-.77-3.698-1.907-5.368-2.464-.324 1.53-3.577 1.531-3.947.066-1.473.525-4.414 1.677-5.413 2.53-2.236 1.906-2.856 6.614-2.987 7.288-.405 2.082-1.161 6.47-.573 7.543.333.609.767 1.37 2.038 2.005l.794.159V38.4h18.217c.557-.432.982-2.687.988-3.809.01-2.176-.552-7.445-1.321-9.75Z"
    />
    <path
      fill="#fff"
      d="M27.82 30.507c6.007-3.532.774-17.84.774-17.84s-6.14-1.586-6.82.03c-2.553 6.05-7.463 15.26-5.843 18.59 3.181-1.493 10.187.222 11.89-.78Z"
    />
    <path
      fill="#fff"
      d="M21.696 15.769s-.413-2.293.32-3.71c.924-1.782 3.681-2.765 5.805-.868 1.478 1.32.701 4.805.701 4.805l-4.63-1.969-2.196 1.742Z"
    />
    <path
      fill="#F7A283"
      d="M26.893 22.88s-1.991.931-3.356-.096l.291-3.922h2.726l.34 4.018ZM22.277 15.366s-.392-.253-.695.15c-.303.404-.101 1.918.656 1.918s.038-2.068.038-2.068ZM28.129 15.366s.391-.253.694.15c.303.404.101 1.918-.656 1.918s-.038-2.068-.038-2.068Z"
    />
    <path
      fill="#F7A283"
      d="M28.256 14.945c0-1.698-1.372-2.81-3.065-2.81-1.692 0-3.065 1.112-3.065 2.81 0 0-.133 2.167-.133 2.273 0 1.613 1.976 3.661 3.199 3.661 1.411 0 3.198-2.439 3.198-3.661 0-.105-.134-2.273-.134-2.273ZM25.172 24.195c1.598 0 2.379-1.574 2.004-1.686A41.975 41.975 0 0 0 25.334 22s-.895.203-2.105.575c-.415.128.39 1.62 1.943 1.62Z"
    />
    <path
      fill="#F16431"
      d="M36.292 39.936c.01-2.176-.551-7.445-1.321-9.75-.48-1.436-1.37-3.934-2.428-5.213-.636-.77-3.697-1.907-5.367-2.464-.324 1.53-3.578 1.531-3.947.066-1.473.525-4.414 1.677-5.414 2.53-2.235 1.906-2.855 6.614-2.987 7.288-.404 2.082-1.16 6.47-.573 7.543.12.22.253.458.434.704h21.553c.032-.245.049-.484.05-.704Z"
    />
    <path
      fill="#151C28"
      d="M4.954 19.998a8.624 8.624 0 1 0 0-17.248 8.624 8.624 0 0 0 0 17.248Z"
    />
    <path
      fill="#151C28"
      d="M1.623 14.248s-.39-2.164.302-3.502c.872-1.683 3.475-2.61 5.48-.82 1.396 1.247.663 4.536.663 4.536l-4.372-1.858-2.073 1.644Z"
    />
    <path
      fill="#402014"
      d="M6.484 20.532s-1.835.97-3.123 0l.274-3.363H6.21l.275 3.363ZM2.171 13.868s-.37-.239-.655.143c-.286.38-.096 1.81.619 1.81.714 0 .036-1.953.036-1.953ZM7.696 13.868s.37-.239.656.143c.286.38.095 1.81-.62 1.81-.714 0-.036-1.953-.036-1.953Z"
    />
    <path
      fill="#402014"
      d="M7.816 13.471c0-1.604-1.295-2.654-2.893-2.654-1.598 0-2.894 1.05-2.894 2.654 0 0-.126 2.046-.126 2.145 0 1.524 1.866 3.457 3.02 3.457 1.332 0 3.02-2.302 3.02-3.457 0-.099-.127-2.145-.127-2.145Z"
    />
    <path
      fill="#fff"
      d="M2.107 16.714a.734.734 0 0 0 .058-.018l-.07-.165a.604.604 0 1 1-.348-1.154l-.046-.173a.783.783 0 0 0 .406 1.51ZM7.704 16.714a.67.67 0 0 1-.07-.023c.018.007.075-.162.075-.162a.604.604 0 1 0 .354-1.152l.047-.173a.783.783 0 0 1-.406 1.51Z"
    />
    <path
      fill="#402014"
      d="M4.892 22.242c1.598 0 2.378-1.573 2.003-1.685-1.058-.317-1.842-.51-1.842-.51s-.895.204-2.105.576c-.415.127.39 1.62 1.944 1.62Z"
    />
    <path
      fill="#6E41CF"
      d="M16.012 37.984c.01-2.177-.552-7.446-1.321-9.75-.48-1.436-1.371-3.934-2.428-5.213-.636-.77-3.698-1.907-5.368-2.464-.324 1.529-3.577 1.531-3.946.066-1.473.525-4.415 1.677-5.414 2.53-2.235 1.906-2.856 6.614-2.987 7.288-.278 1.431-.825 5.32-.948 7.959h22.393c.012-.144.018-.283.019-.416Z"
    />
  </Icon>
);

export default memo(StarredContactsZeroState2Icon);
